import * as React from "react";
import type { PressableProps, ViewStyle } from "react-native";
import { Pressable } from "react-native";

export type AnimatedPressableProps = PressableProps & {
  animate?: (state: { hovered: boolean; pressed: boolean }) => ViewStyle;
};

const AnimatedPressable = React.forwardRef<
  React.ComponentRef<typeof Pressable>,
  AnimatedPressableProps
>(({ animate, style, ...rest }, ref) => {
  return (
    <Pressable
      ref={ref}
      {...rest}
      style={(state) => {
        const base =
          typeof style === "function" ? style(state) : style;
        const animated = animate?.({
          hovered: !!(state as any).hovered,
          pressed: state.pressed,
        });
        return [
          base,
          animated,
          { transition: "all 150ms ease" } as any,
        ];
      }}
    />
  );
});

AnimatedPressable.displayName = "AnimatedPressable";
export default AnimatedPressable;
